import { render, staticRenderFns } from "./DashboardProjects.vue?vue&type=template&id=f70a872c&scoped=true&"
import script from "./DashboardProjects.vue?vue&type=script&lang=js&"
export * from "./DashboardProjects.vue?vue&type=script&lang=js&"
import style0 from "./DashboardProjects.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DashboardProjects.vue?vue&type=style&index=1&id=f70a872c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70a872c",
  null
  
)

export default component.exports